import { render, staticRenderFns } from "./SmallSlider.vue?vue&type=template&id=210144ce&scoped=true&"
import script from "./SmallSlider.vue?vue&type=script&lang=js&"
export * from "./SmallSlider.vue?vue&type=script&lang=js&"
import style0 from "./SmallSlider.vue?vue&type=style&index=0&id=210144ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210144ce",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SmallSlider.vue
// module id = 162
// module chunks = 0